import { formatDistanceStrict as distanceInWords } from 'date-fns'
import { locale } from './locale'

const SECONDS_TO_MILLISECONDS_COEFF = 1000

export const humanTime = (secs) => {
    const ms = secs * SECONDS_TO_MILLISECONDS_COEFF

    return distanceInWords(0, ms, { locale })
}
